module.exports = __webpack_public_path__ + "static/3_section-img-be0c811599e1eaba6ac8b4216710ca02.png";